import React from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const WhatIsAptitude = () => (
  <div id="what-is-aptitude" className="what-is-aptitude">
    <SectionContainer
      className="what-is-aptitude__section"
      paddingTop={80}
      paddingBottom={80}
      backgroundColor="#003399"
    >
      <div className="what-is-aptitude__turquoise-bg-accent"/>
      <Container className="what-is-aptitude__container">
        <Row>
          <Col md="6">
            <Typography component="h2" variant="title" className="text-variant-title-sm what-is-aptitude__title">
              Apa itu Tes Minat Bakat?
            </Typography>
            <Typography component="p" variant="subbody" className="what-is-aptitude__desc">
              Tahukah kamu berdasarkan riset*, sebanyak 87% mahasiswa di Indonesia merasa dirinya salah jurusan? Tes Minat Bakat adalah solusi mudah bagi kamu yang bingung tentang jurusan apa yang harus dipilih saat kuliah nanti. Ikuti tesnya dengan menjawab beberapa soal sederhana tentang diri kamu. Ketahui kelebihan dan kelemahan kamu serta jurusan hingga karier yang cocok dengan kepribadianmu secara langsung!
            </Typography>
            <Typography component="p" variant="note" className="what-is-aptitude__source-note">
              * Menurut Educational Psychologist dari Integrity Development Flexibility (IDF) Irene Guntur, M.Psi., CGA
            </Typography>
          </Col>
          <Col md="6">
            <div className="what-is-aptitude__img-container">
              <Relazsizes
                dataSrc={`${assetsUrl}/assets/img/aptitude/aptitude-phone.png`}
                className="what-is-aptitude__img"
                alt="Apa itu Tes Minat Bakat?"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx global>
      {`
        .what-is-aptitude {
          overflow: hidden;
          &__section {
            position: relative;
            @media screen and (max-width: 767px) {
              padding-bottom: 120px !important;
            }
          }
          &__container {
            position: relative;
          }
          &__title,
          &__desc,
          &__source-note {
            color: #fff !important;
          }
          &__title {
            margin-bottom: 0 !important;
          }
          &__desc {
            line-height: 2;
            margin: 16px 0 !important;
          }
          &__img-container {
            display: none;
            @media screen and (min-width: 768px) {
              display: block;
              padding: 0 32px;
            }
          }
          &__img {
            width: 100%;
          }
          &__turquoise-bg-accent {
            position: absolute;
            background-color: #bcefe2;
            bottom: 0;
            left: 0;
            right: 0;
            height: 20%;
            transform: skewY(-15deg);
            transform-origin: bottom right;
            @media screen and (min-width: 768px) {
              height: 60%;
              transform: skewY(-10deg);
            }
          }
        }
      `}
    </style>
  </div>
)

export default WhatIsAptitude
